import { useNavigate } from "react-router-dom";
import { ActionButtonData } from "../models/clientModels/data/actionButtonData";
import { StyledButton, StyledButtonGroup } from "../styledComponents/StyledListContainer";
import { Link } from "@mui/material";

type ActionButtonProps = {
  data: ActionButtonData[];
  children?: React.ReactNode;
};

const ActionButtonGroup = ({ data, children }: ActionButtonProps) => {
  const navigate = useNavigate();
  return (
    <StyledButtonGroup>
      {data.map((item) => (
        <StyledButton
          key={item.id}
          startIcon={item.icon}
          color={item.colors}
          variant={item.variant}
          size="medium"
          onClick={
            item.link !== undefined && item.link !== null
              ? () => {
                if (item.link) {
                  if (typeof item.link === "string") {
                    navigate(item.link);
                  } else {
                    navigate(item.link);
                  }
                }
              }
              : item.execution !== undefined
                ? item.execution
                : undefined
          }
        >
          {item.anchor ? (
            <Link
              href={item.anchor}
              sx={{ color: item.variant === "contained" ? "#fff" : "#3f51b5" }}
            >
              {item.caption}
            </Link>
          ) : (
            item.caption
          )}
        </StyledButton>
      ))}
      {children}
    </StyledButtonGroup>
  );
};

export default ActionButtonGroup;
